import apis from '@api/client';
import { CompleteProfileUpdateRequest } from '@api/dto';
import { useMutation } from '@tanstack/react-query';

export function useUpdateEmployee(employeeId: string) {
  return useMutation({
    mutationFn: (data: CompleteProfileUpdateRequest) =>
      apis.me
        .completeProfileUpdate({
          employeeId,
          completeProfileUpdateRequest: data,
        })
        .then(res => res.data),
  });
}
